import { handleActions } from 'redux-actions'
import {
  SET_DELIVERY_AMOUNT,
  SET_DELIVERY_COUPON,
  SET_DELIVERY_DATA
} from '../constants/deliveryConstant'
// import { filterTicketWithProduct } from '../utils'

let initState = {
  init: false,
  // 最大可提货数，跟持仓下单数量有关
  maxAmount: 1,
  // 提货数量
  amount: 1,
  // 单价
  unitPrice: 0,
  // {'1': '买涨', '2': '买跌'}
  direction: '1',
  // 商品名
  name: '　',
  // 商品id
  productId: '',
  // 商品图片
  imgSrc: '',
  couponSelected: { couponDesc: '未选择', value: '', price: 0 }
}

let handleTotal = (amount, unit) => {
  let x = Number(unit)
  let z = Number(amount)
  return (x * z).toFixed(2)
}

export let deliveryData = handleActions({
  [SET_DELIVERY_DATA]: (state, action) => {
    let {
      detailsData,
      priceData
    } = action.payload
    let maxAmount = Number(priceData['maxDeliveryNum'])
    let minAmount = Number(priceData['minDeliveryNum'])
    let { ext } = detailsData
    let amount = minAmount
    let unitPrice = priceData['productPrice']

    return {
      ...state,
      init: true,
      productId: detailsData['productId'],
      name: ext['deliveryProductName'],
      maxAmount,
      minAmount,
      //  去空格
      imgSrc: `${ext['deliveryProductPic']}`.replace(/(^\s+)|(\s+$)/g, ''),
      amount,
      unitPrice,
      total: handleTotal(amount, unitPrice)
    }
  },
  [SET_DELIVERY_AMOUNT]: (state, action) => {
    return {
      ...state,
      amount: action.payload,
      total: handleTotal(action.payload, state.unitPrice)
    }
  },
  [SET_DELIVERY_COUPON]: (state, action) => {
    let couponSelected = action.payload
    let { amount, unitPrice } = state
    let total = handleTotal(amount, unitPrice) - couponSelected['price']
    if (total < 0) total = 0
    return {
      ...state,
      total: Number(total.toFixed(2)),
      couponSelected
    }
  }
}, initState)